"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.timeout = void 0;

/**
 * SPDX-FileCopyrightText: © 2019 Liferay, Inc. <https://liferay.com>
 * SPDX-License-Identifier: BSD-3-Clause
 */

/**
 * Implementation of the timeout.
 * Based on: https://github.com/github/fetch/issues/175#issuecomment-125779262
 */
var timeout = function timeout(ms, promise) {
  return new Promise(function (resolve, reject) {
    var timeoutId = setTimeout(function () {
      reject(new Error('timeout'));
    }, ms);
    promise.then(function (res) {
      clearTimeout(timeoutId);
      resolve(res);
    }).catch(function (error) {
      clearTimeout(timeoutId);
      reject(error);
    });
  });
};

exports.timeout = timeout;